export enum ScanMode {
  Camera = 'CAMERA',
  Zebra = 'ZEBRA',
}

export enum ScanTarget {
  Scale = 'SCALE',
  Multiple = 'MULTIPLE',
  Room = 'ROOM',
  Container = 'CONTAINER',
}

export enum ScanState {
  Scanning = 'SCANNING',
  Scanned = 'SCANNED',
}
